import { render, staticRenderFns } from "./SuficienciaModal.vue?vue&type=template&id=c7472978&"
import script from "./SuficienciaModal.vue?vue&type=script&lang=js&"
export * from "./SuficienciaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports